import { z } from "zod";
import { getHeaders } from "../../api/api";
import { readWorkflowBuilderResponse } from "../workflowBuilder/response";
import { homeCandidateSchema, homeRouteSchema, personalRunSchema, type RunRequest } from "./models";

const base = `${String(import.meta.env.VITE_BACKEND_URI ?? "").replace(/\/$/, "")}/home/workflows`;
async function request(path: string, token: string | undefined, signal: AbortSignal, body?: unknown): Promise<unknown> {
    return readWorkflowBuilderResponse(
        await fetch(`${base}${path}`, {
            method: body === undefined ? "GET" : "POST",
            cache: "no-store",
            signal,
            headers: { ...(await getHeaders(token)), "Content-Type": "application/json" },
            ...(body === undefined ? {} : { body: JSON.stringify(body) })
        })
    );
}
export async function routeHome(
    message: string,
    history: { role: "user" | "assistant"; content: string }[],
    language: string,
    token: string | undefined,
    signal: AbortSignal
) {
    return homeRouteSchema.parse(await request("/route", token, signal, { message, history: history.slice(-12), language }));
}
export async function executePersonal(body: RunRequest, token: string | undefined, signal: AbortSignal) {
    return z.object({ run: personalRunSchema }).parse(await request("/runs", token, signal, body)).run;
}
export async function listHomeWorkflowCatalog(token: string | undefined, signal: AbortSignal) {
    return z.object({ candidates: z.array(homeCandidateSchema) }).parse(await request("/catalog", token, signal)).candidates;
}
export async function listPersonalRuns(token: string | undefined, signal: AbortSignal) {
    return z.object({ runs: z.array(personalRunSchema) }).parse(await request("/runs", token, signal)).runs;
}
export async function getPersonalRun(id: string, token: string | undefined, signal: AbortSignal) {
    return z.object({ run: personalRunSchema }).parse(await request(`/runs/${encodeURIComponent(id)}`, token, signal)).run;
}
